import GuaranteeFundBanner from './guarantee-fund-banner';

export default GuaranteeFundBanner;
